/* Collapse for collection description: open only half, rest scrolls inside */
(function () {
  const BOX_SEL   = '.collection-page-description';
  const INNER_SEL = '.collection-desc-content';
  const BTN_CLASS = 'collection-desc-toggle';
  const FLAG      = 'collapseReady';

  const COLLAPSED_PX = 120;  // свернуто: сколько видно (как в CSS)
  const HALF         = 0.3;  // раскрываем на 50% от полного текста
  const MAX_VH       = 0.35; // но не выше 65% высоты окна

  function mount() {
    const box = document.querySelector(BOX_SEL);
    if (!box || box.dataset[FLAG] === '1') return;
    box.dataset[FLAG] = '1';

    // внутренняя обёртка, куда переносим контент (если её нет)
    let inner = box.querySelector(INNER_SEL);
    if (!inner) {
      inner = document.createElement('div');
      inner.className = 'collection-desc-content';
      while (box.firstChild) inner.appendChild(box.firstChild);
      box.appendChild(inner);
    }

    // свернуто по умолчанию
    box.classList.add('is-collapsed');
    box.classList.remove('is-expanded');
    inner.style.maxHeight = COLLAPSED_PX + 'px';

    // кнопка
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = BTN_CLASS;
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';
    box.insertAdjacentElement('afterend', btn);

    // если текста мало — убрать кнопку, оставить раскрытым
    requestAnimationFrame(() => {
      if (inner.scrollHeight <= COLLAPSED_PX + 8) {
        btn.remove();
        box.classList.remove('is-collapsed');
        box.classList.add('is-expanded');
        inner.style.maxHeight = ''; // авто
      }
    });

    btn.addEventListener('click', () => toggle(box, inner, btn));
    window.addEventListener('resize', () => recalc(box, inner));
  }

  // считаем целевую высоту для «раскрыто»: половина текста, но не выше 65vh
  function expandedHeight(inner) {
    const full = inner.scrollHeight;
    const half = Math.round(full * HALF);
    const cap  = Math.round(window.innerHeight * MAX_VH);
    return Math.max(Math.min(half, cap), COLLAPSED_PX + 40); // чуть больше свернутого
  }

  function toggle(box, inner, btn) {
    if (box.classList.contains('is-collapsed')) {
      box.classList.remove('is-collapsed');
      box.classList.add('is-expanded');
      inner.style.maxHeight = expandedHeight(inner) + 'px';
      btn.textContent = 'Read less';
      btn.setAttribute('aria-expanded', 'true');
    } else {
      inner.style.maxHeight = COLLAPSED_PX + 'px';
      box.classList.add('is-collapsed');
      box.classList.remove('is-expanded');
      inner.scrollTop = 0;
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
    }
  }

  function recalc(box, inner) {
    if (!document.body.contains(box)) return;
    if (box.classList.contains('is-collapsed')) {
      inner.style.maxHeight = COLLAPSED_PX + 'px';
    } else {
      inner.style.maxHeight = expandedHeight(inner) + 'px';
    }
  }

  if (document.readyState !== 'loading') mount();
  document.addEventListener('DOMContentLoaded', mount);
  document.addEventListener('shopify:section:load', mount);
})();
